import React from "react"
import SEO from "../../components/seo"
import Layout from "../../components/layout"
import EndorsementsLayout from "../../components/endorsements-layout"

export default function Governor() {
  return (
    <Layout>
      <SEO title="Governor Endorsements" />
      <EndorsementsLayout title="Governor Endorsements">
        <iframe
          src="https://docs.google.com/spreadsheets/d/e/2PACX-1vS1vqALmj5faDb3D9ccipHGwPtuhM4EgIIL67H6CZMWgvrzHnXpyJ5V2wIXVO-ywK4-DSU_YGho_hAx/pubhtml?gid=353268906&amp;single=true&amp;widget=true&amp;headers=false"
          className="w-full"
          height={500}
        ></iframe>
      </EndorsementsLayout>
    </Layout>
  )
}
